import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';

import SliderBanner from '../../components/Home/SliderBanner';
import TopBanners from '../../components/Home/TopBanners';
import MiddleBanners from '../../components/Home/MiddleBanners';
import BottomBanner from '../../components/Home/BottomBanner';

import apiBanners from '../../api/Home';
import { spanish } from '../../config/config';

const HomePage = () => {
  const [slides, setSlides] = useState(null);
  const [banners, setBanners] = useState(null);
  useEffect(async () => {
    setSlides(await apiBanners.getSlider());
    setBanners(await apiBanners.getBanners());
  }, []);
  return (
    <>
      <Helmet
        title="Forever Living | Tienda Online"
        meta={[
          {
            name: 'description',
            content: spanish
              ? 'Forever Living es el mayor productor, fabricante y distribuidor de Aloe Vera del mundo. Descubra los productos de Forever Living y aprenda más sobre cómo convertirse en propietario de un negocio para siempre aquí.'
              : 'Forever Living is the world’s largest grower, manufacturer and distributor of Aloe Vera. Discover Forever Living Products and learn more about becoming a forever business owner here.',
          },
        ]}
      />
      <SliderBanner data={slides} />
      <TopBanners data={banners} />
      <MiddleBanners data={banners} />
      <BottomBanner data={banners} />
    </>
  );
};

export default HomePage;
